<template>
    <div >
        <el-tabs v-if="pageTabArr.length > 0" value="label_0" @tab-click="pageTabClick">
            <el-tab-pane v-for="(one,index) in pageTabArr" :key="index"  :label="one.label" :name="'label_'+(one.index?one.index:index)"></el-tab-pane>
        </el-tabs>
        <el-container>
            <el-aside v-if="leftBlockInfo.blockWidth != 0" :width="leftBlockInfo.blockWidth">

            </el-aside>
            <el-main style="padding:5px;">
                <div name= "searchTab">
                    <!-- 图标和报表切换按钮 -->
                    <el-tooltip v-if="pageSet.styleSet && pageSet.styleSet.ifChart == 3" class="item" effect="dark" content="图表只可选中一个分组属性！数据报表行分组和列分组需要各至少选中一个属性！"
                        placement="top">
                        <el-switch
                            v-model="reportType"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="图表"
                            inactive-text="数据报表"
                            @change="changeReportType"
                        >
                        </el-switch>
                    </el-tooltip>
                    <!-- 搜索条件的 折叠面板 -->
                    <div v-if="!pageSet.styleSet || pageSet.styleSet.ifShowSearch != 2" v-show="pageSet.ifUnfoldsrch == 1">
                        <ListSearch ref='ListSearch' :searchSetArr="searchSetArr"  :ifIncludeSearch="1" @initSearchData="initSearchData" ></ListSearch>
                    </div>
                    <el-button-group>
                        <el-button v-if="!pageSet.styleSet || pageSet.styleSet.ifShowSearch != 2" type="primary" @click="initSearchData" icon="el-icon-search"></el-button>
                        <el-button v-if="!pageSet.styleSet || pageSet.styleSet.ifShowSearch != 2" type="primary" @click="unfoldSearch">{{pageSet.ifUnfoldsrch==1?'收起搜索':'展开搜索'}}</el-button>
                        <!-- 切换图表类型 -->
                        <el-dropdown v-if="reportType && (!pageSet.styleSet || !pageSet.styleSet.chartType)" trigger="click" @command="changeChartType" >
                            <el-button type="primary" id="buttonId">
                                {{chartType}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" id="menuId">
                                <el-dropdown-item v-for="(one,index) in chartTypeArr" :key="index" :command="index"
                                >{{one}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- 切换图表分组维度 -->
                        <el-dropdown v-if="reportType && (!pageSet.styleSet || !pageSet.styleSet.ifGroupChange)" trigger="click" @command="changeChartGroup" >
                            <el-button type="primary" id="buttonId">
                                {{groupCheckOne.cnName}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" id="menuId">
                                <el-dropdown-item v-for="(one,index) in groupArr" :key="index" :command="index"
                                >{{one.cnName}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown v-if="(!pageSet.styleSet || pageSet.styleSet.ifExport==1)" trigger="click" @command="operaButtonCommand" >
                            <el-button type="primary" id="buttonId">
                                {{buttonMenuName}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" id="menuId">
                                <el-dropdown-item :command="-1">导出</el-dropdown-item>
                                <el-dropdown-item v-for="(one,index) in operaButtonArr" :key="index" :command="index"
                                >{{one.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-button-group>
                   
                </div>
                 <!-- 数据报表时 在页面切换分组条件和日期格式 -->
                <el-form v-if="pageSet.ifDataGroupChange == 1"
                    :inline="true" :model="reportSetData" label-suffix=":" size="small" label-width="100px" >
                    <el-row type="flex" style="flex-wrap:wrap;" >
                        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
                            <el-form-item label="列分组" >
                                <el-checkbox-group v-model="reportSetData.colCheckList"
                                    @change="colGroupChooseChange"
                                    :min="reportSetData.colMin"
                                    :max="reportSetData.colMax"
                                >
                                    <el-checkbox v-for="(colOne,colIndex) in pageSet.colFieldList" :key="colIndex" 
                                        :label="colIndex"
                                    >{{colOne.cnName}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
                            <el-form-item label="行分组" >
                                <el-checkbox-group v-model="reportSetData.rowCheckList"
                                    @change="rowGroupChooseChange"
                                    :min="reportSetData.rowMin"
                                    :max="reportSetData.rowMax"
                                >
                                    <el-checkbox v-for="(rowOne,rowIndex) in pageSet.rowFieldList" :key="rowIndex" 
                                        :label="rowIndex"
                                    >{{rowOne.cnName}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
                            <el-form-item label="日期及统计" >
                                <el-select v-model="reportSetData.dateType" placeholder="请选择"
                                    style="width:90px;"
                                >
                                    <el-option
                                    v-for="item in dateSearchArr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-select v-model="reportSetData.rowOrCol" placeholder="请选择"
                                    style="width:90px;"
                                >
                                    <el-option key="0" label="竖向" value="0"></el-option>
                                    <el-option key="1" label="横向" value="1"></el-option>
                                </el-select> -->
                                
                            </el-form-item>
                            
                        </el-col>
                    </el-row>
                </el-form>
                <div v-if="!reportType" >
                    <el-table 
                        :data="pageTableData"
                        style="width: 100%"
                        :max-height="tableMaxHeight"
                        size="mini"
                        :span-method="objectSpanMethod"
                        @cell-dblclick="cellDbClick"
                        @cell-click="cellClick"
                        :cell-style="getCellStyle"
                        v-loading="loading"
                        >
                        <el-table-column v-for="(oneHead,oneHeadIndex) in tableHead" :key="oneHeadIndex"
                        :prop="oneHead.enName"
                        :label="oneHead.cnName"
                        :fixed="oneHead.fixed"
                        align="center"
                        :width="tdWidth">
                            <el-table-column v-for="(twoHead,twoHeadIndex) in oneHead.children" :key="twoHeadIndex"
                            :prop="twoHead.enName"
                            :label="twoHead.cnName"
                            align="center"
                            :width="tdWidth">
                                <el-table-column v-for="(threeHead,threeHeadIndex) in twoHead.children" :key="threeHeadIndex"
                                :prop="threeHead.enName"
                                :label="threeHead.cnName"
                                align="center"
                                :width="tdWidth">

                                </el-table-column>
                                
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                    <el-pagination v-if="ifCurrent==1"
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :total="tableData.length">
                    </el-pagination>
                </div>
                <div v-else v-loading="loading">
                    <ve-line v-if="chartType=='折线图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet &&pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-line>
                    <ve-histogram v-else-if="chartType=='柱状图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'" ></ve-histogram>
                    <ve-bar v-else-if="chartType=='条形图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-bar>
                    <ve-pie v-else-if="chartType=='饼图'" :data="chartData" :settings="pieChartSettings" :extend="pieChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-pie>
                    <ve-ring v-else-if="chartType=='环图'" :data="chartData" :settings="pieChartSettings" :extend="pieChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-ring>
                    <ve-waterfall v-else-if="chartType=='瀑布图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-waterfall>
                    <ve-funnel v-else-if="chartType=='漏斗图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-funnel>
                    <ve-radar v-else-if="chartType=='雷达图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-radar>
                    <ve-heatmap v-else-if="chartType=='热力图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-heatmap>
                    <ve-scatter v-else-if="chartType=='散点图'" :data="chartData" :settings="chartSettings" :extend="defaultChartOptions" :events="tenDepChartEvents" :height="(pageSet.styleSet && pageSet.styleSet.chartHeigth)?pageSet.styleSet.chartHeigth:'400px'" :width="(pageSet.styleSet && pageSet.styleSet.chartWidth)?pageSet.styleSet.chartWidth:'auto'"></ve-scatter>
                </div>
            </el-main>
            <el-aside v-if="rightBlockInfo.blockWidth != 0" :width="rightBlockInfo.blockWidth" :style="'height:'+tableMaxHeight+'px'">
                <el-button type="primary" @click="changeBlockFlag" >{{rightBlockInfo.buttonName}}</el-button>
                <ListPage v-if="rightBlockInfo.blockType == 1" ref="rightBlockPage" 
                    :initPageInfo="rightBlockInfo.blockInfo">
                </ListPage>
                <kw_list v-else-if="rightBlockInfo.blockType == 2" ref="rightBlockPage" :initPageObj="rightBlockInfo.blockInfo" :isLimitButton="isLimitButton"></kw_list>
            </el-aside>
        </el-container>
    </div>
</template>

<script>
import Vue from 'vue'
import pageUtils from '@/js/page/pageUtil.js'
import utils from '@/js/utils/util.js'
import $ from 'jquery';
import ListPage from '@/components/page/ListPage.vue'
import ListSearch from '@/components/page/ListSearch.vue'
import VCharts from 'v-charts'
Vue.use(VCharts);

export default {
  name: 'Report',
  components:{
    ListPage, 
    ListSearch,
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  props: {
    pageInfo: Object,
    initReportType:Number,
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
  },
  data(){
    const self = this;
    this.tenDepChartEvents = {
        dblclick: function(e) {
            self.tenDepChartClicked(e);
        }
    }
    return {
        loading:false,
        pageSet:{
            ifUnfoldsrch:0
        },
        //报表主键
        reportId:0,
        searchSetArr:[],
        //报表的数据信息
        tableData:[],
        //如果分页进行显示的 这一页的数据
        pageTableData:[],
        //报表的表头信息
        tableHead:[],
        //是否分页显示数据
        ifCurrent:0,
        //分页显示 当前是第几页
        currentPage:0,
        //分页 每页条数
        pageSize:10,
        //数据渲染过程中的动态数据
        initAutoData:{
            dataRows:[],
            startIndex:0,
            tmpHeadGroupMap:{},
            tmpHeadMap:{},
            tmpDataMap:{},
            colIndex:0
        },
        //报表分组及日期显示设置
        reportSetData:{
            colCheckList: [],
            rowCheckList: [],
            dateType:"0",
            rowOrCol:"0",
            rowMin:1,
            rowMax:0,
            colMin:1,
            colMax:0
        },
        tableMaxHeight:450,
        tdWidth:130,
        dateSearchArr:[
            {
                label:"默认",
                value:"0"
            },
            {
                label:"年",
                value:"year"
            },
            {
                label:"月",
                value:"month"
            },
            {
                label:"日",
                value:"day"
            },
            {
                label:"总和",
                value:"all"
            }
        ],
        //true为图片  false为 文字报表
        reportType:false,
        //图表数据
        chartData:[],
        //图表设置信息
        chartSettings:{
            
        },
        // 饼图等图标的设置信息
        pieChartSettings:{
            
        },
        // 饼图的样式设置信息
        pieChartOptions:{

        },
        // 图标的样式设置信息
        defaultChartOptions:{
            xAxis:{
                axisLabel:{
                    // lineHeight: 200,
                    // fontSize:14,
                    interval:0,
                    formatter : (params) => {
                        let newParamsName = '';// 最终拼接成的字符串

                        let paramsNameNumber = params.length;// 实际标签的个数

                        let provideNumber = 10;// 每行能显示的字的个数
                        if(self.chartData.rows.length > 6) {
                            provideNumber = 6;
                        }

                        let rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整

                        /**

                        * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签

                        */

                        // 条件等同于rowNumber>1

                        if (paramsNameNumber > provideNumber) {
                        /** 循环每一行,p表示行 */

                        for (let p = 0; p < rowNumber; p++) {
                        let tempStr = '';// 表示每一次截取的字符串

                        let start = p * provideNumber;// 开始截取的位置

                        let end = start + provideNumber;// 结束截取的位置

                        // 此处特殊处理最后一行的索引值

                        if (p === rowNumber - 1) {
                        // 最后一次不换行

                        tempStr = params.substring(start, paramsNameNumber);

                        } else {
                        // 每一次拼接字符串并换行

                        tempStr = params.substring(start, end) + '\n';

                        }

                        newParamsName += tempStr;// 最终拼成的字符串

                        }

                        } else {
                        // 将旧标签的值赋给新标签

                        newParamsName = params;

                        }

                        //将最终的字符串返回

                        return newParamsName

                        }
                }
            }
        },
        chartTypeArr:[
            "折线图",
            "柱状图",
            "条形图",
            "饼图",
            "环图",
            // "瀑布图",
            // "漏斗图",
            "雷达图",
            // "热力图",
            "散点图"
        ],
        //图表类型 默认为折线图
        chartType:"柱状图",
        // 所有的分组条件
        groupArr:[],
        // 图表当前选中的 分组条件
        groupCheckOne:{
            cnName:"",
            type:"",
            index:0
        },
        //右侧块信息
        rightBlockInfo:{
            //块宽度,默认为0代表不显示  200px
            blockWidth:0,
            //块显示内容  1:列表  
            blockType:0,
            //块的相关信息
            blockInfo:{

            },
            buttonName:"收起"
        },
        //左侧块信息
        leftBlockInfo:{
            //块宽度,默认为0代表不显示  200px
            blockWidth:0,
            //块显示内容  1:列表  
            blockType:0,
            //块的相关信息
            blockInfo:{

            }
        },
        //操作按钮组的 按钮名称
        buttonMenuName:"",
        //操作按钮的操作数据主键
        buttonDataId:0,
        //操作按钮的 按钮内容
        operaButtonArr:[],
        // 页签选项卡数据 最上边的页面切换选项卡
        pageTabArr:[]
    }
  },
  methods:{
    /**
     * 切换搜索条件的隐藏显示
     */
    unfoldSearch() {
        var pageSet = this.pageSet;
        this.pageSet.ifUnfoldsrch = this.pageSet.ifUnfoldsrch==1?0:1;
    },
    /**
     * 分组选中时 进行判断 如果是图表则行列分组只能选中一个 如果是数据报表 行列分组都至少选中一个
     */
    rowGroupChooseChange(checkList){
        var reportSetData = this.reportSetData;
        var reportType = this.reportType;
        if(reportType) {
            if(checkList.length > 1) {
                checkList.splice(0,checkList.length-1);
            }
            reportSetData.colCheckList = [];
            this.initSearchData();
        }
    },
    colGroupChooseChange(checkList){
        var reportSetData = this.reportSetData;
        var reportType = this.reportType;
        if(reportType) {
            if(checkList.length > 1) {
                checkList.splice(0,checkList.length-1);
            }
            reportSetData.rowCheckList = [];
            this.initSearchData();
        }
    },
    /**
     * 数据报表 和 图表切换时 进行分组条件选中的验证切换
     */
    changeReportType() {
        var that = this;
        var reportSetData = this.reportSetData;
        var reportSet = this.pageSet;
        var reportType = this.reportType;
        if(reportType) {
            var groupArr = [];
            reportSet.rowFieldList.forEach((element,rowFieldIndex) => {
                groupArr.push({
                    type:"row",
                    cnName:element.cnName,
                    index:rowFieldIndex
                })
            });
            reportSet.colFieldList.forEach((element,colFieldIndex) => {
                groupArr.push({
                    type:"col",
                    cnName:element.cnName,
                    index:colFieldIndex
                })
            });
            this.groupArr = groupArr;
            if(reportSet.styleSet && reportSet.styleSet.chartType) {
                this.chartType = reportSet.styleSet.chartType
            }
            this.changeChartGroup(0);
            // 
            //图表 最大选中个数一个
            reportSetData.rowMin = 0;
            reportSetData.colMin = 0;
            //reportSetData.rowMax = 1;
            //reportSetData.colMax = 1;
            this.initSearchData();
        } else {
            //默认选中全部
            var rowCheckList = [];
            reportSet.rowFieldList.forEach((element,rowFieldIndex) => {
                rowCheckList.push(rowFieldIndex);
            });
            reportSetData.rowCheckList = rowCheckList;
            var colCheckList = [];
            reportSet.colFieldList.forEach((element,colFieldIndex) => {
                colCheckList.push(colFieldIndex);
            });
            reportSetData.colCheckList = colCheckList;

            //数据报表  最小选中个数一个
            reportSetData.rowMin = 1;
            reportSetData.colMin = 1;
            delete reportSetData.rowMax;
            delete reportSetData.colMax;
            that.initSearchData();
        }
    },

    /**
     * 加载报表数据
     */
    initSearchData(){
        var that = this;
        //打开遮罩层
        this.loading = true;
        
        //获取页面ID
        var rid = this.reportId;
            
        this.pageSet.ifUnfoldsrch = "0";
        var toHtData = {};
        //报表主键
        toHtData.rid = rid;
        var toHtSearchData = {};
        if(this.$refs.ListSearch) {
            toHtSearchData = this.$refs.ListSearch.toHtSearchData;//this.toHtSearchData;
        }
        //进行搜索条件 是否必填的判断
        var searchFlag = true;
        var searchError = "";
        this.searchSetArr.forEach(one => {
            if(one.ifMustReg == 1) {
                if(toHtSearchData[one.fieldAliasName+'_strVal_pld'] == null || toHtSearchData[one.fieldAliasName+'_strVal_pld']=="") {
                    searchFlag = false;
                    searchError += one.fieldCnName+"是必须填写的!";
                }
            }
        });
        if(!searchFlag) {
            that.$message.error('不可以进行搜索:'+searchError);
            that.loading = false;
            return;
        }
        for (var key in toHtSearchData) {
            if(key != "freeTimeSearchArr") {
                if(typeof(toHtSearchData[key]) == "object" && toHtSearchData[key] != null) {
                    var tmpId = "";
                    toHtSearchData[key].forEach(element => {
                        if(tmpId != "") {
                            tmpId += ",";
                        }
                        tmpId += element;
                    });
                    toHtData[key] = tmpId; 
                } else {
                    toHtData[key] = toHtSearchData[key];
                }
            }
        }

        //传递至后台的行分组 列分组 日期
        var reportSetData = this.reportSetData;
        var colCheckList = reportSetData.colCheckList;
        var rowCheckList = reportSetData.rowCheckList;
        if(colCheckList != null && colCheckList.length > 0) {
            toHtData.colEnNameIndex = colCheckList;
        }
        if(rowCheckList != null && rowCheckList.length > 0) {
            toHtData.rowEnNameIndex = rowCheckList;
        }
        var dateType = reportSetData.dateType;
        toHtData.dateType = dateType;

        var tmpPageSet = that.pageSet;
        //列分组信息
        var colFieldList = [];
        colCheckList.forEach(element => {
            colFieldList.push(tmpPageSet.colFieldList[element]);
        });
        //行分组信息
        var rowFieldList = [];
        rowCheckList.forEach(element => {
            rowFieldList.push(tmpPageSet.rowFieldList[element]);
        });

        that.tableHead = [];
        that.tableData = [];
        //如果是图表
        if(that.reportType) {
            toHtData.reportType = "chart";
        }

        var url = "/report_getJzReportDataAjax.do";
        //进行后台数据搜索
        utils.request(that,{
            url:url,
            data:toHtData,
            success: function (res) {
                that.loading = false;
                //关闭遮罩层
                //赋值当前页的数据进行页面显示
                var dataRows = res.data;
                that.initAutoData = {
                    dataRows:[],
                    startIndex:0,
                    tmpHeadGroupMap:{},
                    tmpHeadMap:{},
                    tmpDataMap:{},
                    colIndex:0
                }
                if (that.reportType) {
                    //别名和中文名的 Map
                    var labelMap = {};
                    //分组属性
                    var dimension = [];
                    //统计值
                    var metrics = [];
                    var columns = [];
                    //列名 包含
                    rowFieldList.forEach(element => {
                        labelMap[element.enName] = element.cnName;
                        dimension.push(element.enName);
                        columns.push(element.enName);
                    });
                    colFieldList.forEach(element => {
                        labelMap[element.enName] = element.cnName;
                        dimension.push(element.enName);
                        columns.push(element.enName);
                    });
                    //统计值信息
                    var showFieldList = tmpPageSet.showFieldList;
                    showFieldList.forEach(element => {
                        labelMap[element.enName] = element.cnName;
                        metrics.push(element.enName);
                        columns.push(element.enName);
                    });
                    var chartSettings = {};
                    chartSettings.labelMap = labelMap;
                    //统计值
                    chartSettings.metrics = metrics;
                    chartSettings.dimension = dimension;
                    chartSettings.legendLimit = 5;

                    var chartData = {};
                    chartData.columns = columns;
                    chartData.rows = dataRows;
                    
                    that.chartSettings = chartSettings;
                    that.chartData = chartData;
                    that.initChartOptions(that.chartType);
                } else {
                    that.initAutoData.dataRows = dataRows;
                    that.currentPage = 0;
                    that.initReportData(tmpPageSet,rowFieldList,colFieldList);
                }
            }
        })
        // if(that.rightBlockInfo) {
        //     // 调用右侧组件刷新
        //     var prevBlockType = that.rightBlockInfo.blockType;
        //     that.rightBlockInfo.blockType = 0;
        //     that.$nextTick(function(){
        //         that.rightBlockInfo.blockType  = prevBlockType;
        //     });
        // }
    },
    /**
     * 导出数据
     */
    exportReport() {
        var that = this;
        
        //获取页面ID
        var rid = this.reportId;
            
        var toHtData = {};
        //报表主键
        toHtData.rid = rid;

        var toHtSearchData = this.$refs.ListSearch.toHtSearchData;//this.toHtSearchData;
        //进行搜索条件 是否必填的判断
        var searchFlag = true;
        var searchError = "";
        this.searchSetArr.forEach(one => {
            if(one.ifMustReg == 1) {
                if(toHtSearchData[one.fieldAliasName+'_strVal_pld'] == null || toHtSearchData[one.fieldAliasName+'_strVal_pld']=="") {
                    searchFlag = false;
                    searchError += one.fieldCnName+"是必须填写的!";
                }
            }
        });
        if(!searchFlag) {
            that.$message.error('不可以进行搜索:'+searchError);
            that.loading = false;
            return;
        }
        for (var key in toHtSearchData) {
            if(key != "freeTimeSearchArr") {
                if(typeof(toHtSearchData[key]) == "object" && toHtSearchData[key] != null) {
                    var tmpId = "";
                    toHtSearchData[key].forEach(element => {
                        if(tmpId != "") {
                            tmpId += ",";
                        }
                        tmpId += element;
                    });
                    toHtData[key] = tmpId; 
                } else {
                    toHtData[key] = toHtSearchData[key];
                }
            }
        }

        //传递至后台的行分组 列分组 日期
        // var reportSetData = this.reportSetData;
        // var colCheckList = reportSetData.colCheckList;
        // var rowCheckList = reportSetData.rowCheckList;
        // if(colCheckList != null) {
        //     toHtData.colEnNameIndex = colCheckList;
        // }
        // if(rowCheckList != null) {
        //     toHtData.rowEnNameIndex = rowCheckList;
        // }
        // var dateType = reportSetData.dateType;
        // toHtData.dateType = dateType;
        var baseURL = that.GLOBAL.baseURL;
        var url = baseURL + "report_ajaxJzList.do?sourceType=1";
        for (var key in toHtData) {
            url += "&" + key + "=" + toHtData[key];
        }
        window.open(url);
    },

    /**
     * 生成数据报表所需要的内容
     */
    initReportData(tmpPageSet,rowFieldList,colFieldList) {
        var that = this;
        //统计值信息
        var showFieldList = tmpPageSet.showFieldList;
        var showFieldLength = showFieldList.length;
        this.showFieldLength = showFieldLength;
        
        // var tableData = this.tableData;
        var tableHead = this.tableHead;

        var initSumRowData = {};
        //行分组的个数
        var rowFieldSize = rowFieldList.length;
        this.rowFieldSize = rowFieldSize;

        //根据行分组 进行(行合并)的临时记录信息
        var rowJsonMerge = {};

        //把行分组拼接为表头信息
        var tmpIndex = 0;
        rowFieldList.forEach((element,rowFieldIndex) => {
            element.fixed = "left";
            var ifShow = element.ifShow;
            if(ifShow == 1) {
                tableHead.push(element);
            }
            initSumRowData[element.enName] = "总计";
            rowJsonMerge["prevValue_"+rowFieldIndex] = "";
            rowJsonMerge["prevData_"+rowFieldIndex] = {};
            rowJsonMerge["prevIndex_"+rowFieldIndex] = 0;
            tmpIndex++;
        });

        if(tmpPageSet.ifHideTjCol != 1) {
            var firstHeadOne = {};
            var prevHeadOne = null;
            colFieldList.forEach((colFieldOne,colFieldIndex) => {
                var colHeadOne = {};
                colHeadOne.fixed = "left";
                colHeadOne.cnName = colFieldOne.cnName;
                colHeadOne.enName = "showField";
                
                if(colFieldIndex == 0) {
                    firstHeadOne = colHeadOne;
                } else {
                    prevHeadOne.children = [colHeadOne];
                }
                prevHeadOne = colHeadOne;
            })
            tableHead.push(firstHeadOne);
        }

        //
        //var tmpTableHead = [];

        //循环数据 进行列分组的表头拼接 支持子表头的拼接
        //根据存放是否拼接过 
        this.rowDataCl();
        // console.log("tableData==========11=============",tableData)

        //进行列分组的排序 a,b表示数组中的任意两个元素，若return > 0 b前a后；reutrn < 0 a前b后；a=b时存在浏览器兼容
        /*tmpTableHead.sort(function(a,b){
            if(a.cnName > b.cnName) {
                return 1;
            } else {
                return -1;
            }
        });*/
        // tmpTableHead.forEach(element => {
        //     tableHead.push(element);
        // });

        // //进行竖向总和的计算
        // var sumDataArr = [];
        // showFieldList.forEach((showFieldOne,showFieldIndex) => {
        //     var cnName = showFieldOne.cnName;
        //     var oneRowJson = JSON.parse(JSON.stringify(initSumRowData));
        //     oneRowJson.showField = cnName;
        //     sumDataArr.push(oneRowJson);
        // })
        // //循环一遍tableData进行总和的计算
        // tableData.forEach((oneRowData,rowIndex) => {
        //     //进行行合并数值的计算
        //     /*rowFieldList.forEach((rowFieldOne,rowFieldIndex) => {
        //         //当前的行的值信息
        //         var rowFieldDataRow = oneRowData[rowFieldOne.enName];
        //         //当前记录的之前的行的值信息 
        //         var prevRowValue = rowJsonMerge["prevValue_"+rowFieldIndex];
        //         if(prevRowValue != rowFieldDataRow) {
        //             //修改之前的json的合并行行数
        //             var prevJson = rowJsonMerge["prevData_"+rowFieldIndex];
        //             var prevIndex = rowJsonMerge["prevIndex_"+rowFieldIndex];
        //             console.log("rowIndex======================prevIndex",rowFieldIndex,rowIndex,prevIndex);
                    
        //             prevJson["merge_"+rowFieldIndex] = (rowIndex-prevIndex);
        //             //记录当前行为新的可能的合并行
        //             rowJsonMerge["prevValue_"+rowFieldIndex] = rowFieldDataRow;
        //             rowJsonMerge["prevData_"+rowFieldIndex] = oneRowData;
        //             rowJsonMerge["prevIndex_"+rowFieldIndex] = rowIndex;
        //         }
                
        //     });*/


        //     //行总和  获取本行的计算类型
        //     var showFieldIndex = rowIndex%showFieldLength;
        //     var sumCheck = showFieldList[showFieldIndex].sumCheck;
        //     var rowSum = 0;
        //     var rowNum = 0;
        //     //进行横向和纵向总和的计算
        //     for (let index = 0; index < colIndex; index++) {
        //         const tmpValue = oneRowData["row_"+index];
        //         if(tmpValue && !isNaN(tmpValue)) {
        //             rowSum += tmpValue*1;
        //             rowNum ++;
        //             var nowSumDataSum = sumDataArr[showFieldIndex]["row_"+index+"_sum"];
        //             var nowSumDataNum = sumDataArr[showFieldIndex]["row_"+index+"_num"];
        //             if(!nowSumDataSum) {
        //                 nowSumDataSum = 0;
        //                 nowSumDataNum = 0;
        //             }
        //             nowSumDataSum += tmpValue*1;
        //             nowSumDataNum ++;
        //             sumDataArr[showFieldIndex]["row_"+index+"_sum"] = nowSumDataSum;
        //             sumDataArr[showFieldIndex]["row_"+index+"_num"] = nowSumDataNum;
        //             switch (sumCheck) {
        //                 case "0": //记录数
        //                     sumDataArr[showFieldIndex]["row_"+index] = nowSumDataSum;
        //                     break;
        //                 case "1": //去重合并
        //                     break;
        //                 case "2": //最大值
        //                     break;
        //                 case "3": //最小值
        //                     break;
        //                 case "4": //总和
        //                     sumDataArr[showFieldIndex]["row_"+index] = nowSumDataSum;
        //                     break;
        //                 case "5": //平均值
        //                     if(nowSumDataNum>0) {
        //                         sumDataArr[showFieldIndex]["row_"+index] = nowSumDataSum/nowSumDataNum;
        //                     }
        //                 case "6": //合并
        //                     break;
        //                 case "7": //去重记录数
        //                     sumDataArr[showFieldIndex]["row_"+index] = nowSumDataSum;
        //                     break;
        //                 default:
        //                     break;
        //             }
        //         }
        //     }
        //     switch (sumCheck) {
        //         case "0": //记录数
        //             oneRowData.sum = rowSum;
        //             break;
        //         case "1": //去重合并
        //             break;
        //         case "2": //最大值
        //             break;
        //         case "3": //最小值
        //             break;
        //         case "4": //总和
        //             oneRowData.sum = rowSum;
        //             break;
        //         case "5": //平均值
        //             if(rowNum>0) {
        //                 oneRowData.sum = rowSum/rowNum;
        //             }
        //         case "6": //合并
        //             break;
        //         case "7": //去重记录数
        //             oneRowData.sum = rowSum;
        //             break;
        //         default:
        //             break;
        //     }
        // });
        // sumDataArr.forEach((element,showFieldIndex) => {
        //     var sumCheck = showFieldList[showFieldIndex].sumCheck;
        //     var rowSum = 0;
        //     var rowNum = 0;
        //     //进行横向和纵向总和的计算
        //     for (let index = 0; index < colIndex; index++) {
        //         const tmpValue = element["row_"+index];
        //         if(tmpValue && !isNaN(tmpValue)) {
        //             rowSum += tmpValue*1;
        //             rowNum ++;
        //         }
        //     }
        //     switch (sumCheck) {
        //         case "0": //记录数
        //             element.sum = rowSum;
        //             break;
        //         case "1": //去重合并
        //             break;
        //         case "2": //最大值
        //             break;
        //         case "3": //最小值
        //             break;
        //         case "4": //总和
        //             element.sum = rowSum;
        //             break;
        //         case "5": //平均值
        //             if(rowNum>0) {
        //                 element.sum = rowSum/rowNum;
        //             }
        //         case "6": //合并
        //             break;
        //         case "7": //去重记录数
        //             element.sum = rowSum;
        //             break;
        //         default:
        //             break;
        //     }
            
        // });
        // tableHead.push({
        //     fixed : (tableHead.length>10?"right":null),
        //     cnName : "总和",
        //     enName : "sum"
        // });

        //进行报表的显示处理
        //获取表头信息 列分组数据
        // that.tableHead = tableHead;
        // that.tableData = tableData;
    },

    rowDataCl(){
        var that = this;
        var initAutoData = that.initAutoData;
        var dataRows = initAutoData.dataRows;
        //var startIndex = initAutoData.startIndex;
        // var tmpHeadGroupMap = initAutoData.tmpHeadGroupMap;
        // var tmpHeadMap = initAutoData.tmpHeadMap;
        // var tmpDataMap = initAutoData.tmpDataMap;
        //var colIndex = initAutoData.colIndex;
        var rowFieldList = that.pageSet.rowFieldList;
        var colFieldList = that.pageSet.colFieldList;
        var showFieldList = that.pageSet.showFieldList;

        // var tableData = this.tableData;
        var tableHead = this.tableHead;
        var endIndex = 1000;
        if(dataRows.length > initAutoData.startIndex+1000) {
            endIndex = 1000;
        } else {
            endIndex = dataRows.length - initAutoData.startIndex;
        }
        endIndex = dataRows.length;
        for (let index = initAutoData.startIndex; index < initAutoData.startIndex+endIndex; index++) {
            const element = dataRows[index];
            var prevTableHeadOne = initAutoData.tmpHeadGroupMap;
            var colKey = "";
            //循环列分组
            colFieldList.forEach((colFieldOne,colFieldIndex) => {
                var colFieldDataRow = element[colFieldOne.enName];
                if(colKey != "") {
                    colKey+="/";
                }
                colKey+=colFieldDataRow;

                var ifAddToHead = true;
                var tableHeadOne = {};
                if(colFieldIndex != 0) {

                }
                if(initAutoData.tmpHeadGroupMap[colKey]) {
                    ifAddToHead = false;
                    tableHeadOne = initAutoData.tmpHeadGroupMap[colKey];
                } else {
                    tableHeadOne = {cnName:colFieldDataRow,enName:"row_"+initAutoData.colIndex,children:[]};
                    initAutoData.tmpHeadGroupMap[colKey] = tableHeadOne;
                }
                if(ifAddToHead) {
                    if(colFieldIndex == 0) {
                        //如果不存在 则进行添加
                        tableHead.push(tableHeadOne);
                    } else {
                        prevTableHeadOne.children.push(tableHeadOne);
                    }
                }
                prevTableHeadOne = tableHeadOne;
            });
            

            //循环行分组
            var initOneRowJson = {};
            var rowKey = "";
            rowFieldList.forEach((rowFieldOne,rowFieldIndex) => {
                var rowFieldDataRow = element[rowFieldOne.enName];
                if(rowKey != "") {
                    rowKey+="/";
                }
                rowKey+=rowFieldDataRow;
                initOneRowJson[rowFieldOne.enName] = rowFieldDataRow;
            });
            
            if(!initAutoData.tmpHeadMap[colKey]) {
                initAutoData.tmpHeadMap[colKey] = {colIndex:initAutoData.colIndex};
                initAutoData.colIndex++;
            }
            
            //进行统计值的计算
            showFieldList.forEach((showFieldOne,showFieldIndex) => {
                //统计值的别名
                var enName = showFieldOne.enName;
                //统计值的中文名
                var cnName = showFieldOne.cnName;
                //统计值的合并方式
                var sumCheck = showFieldOne.sumCheck;
                //统计值的穿透类型
                var ctPageType = showFieldOne.ctPageType;
                //统计值的穿透页面ID
                var ctPageId = showFieldOne.ctPageId;
                //统计值的穿透表格ID
                var ctPageObjTableId = showFieldOne.ctPageObjTableId;


                var showFieldDataRow = element[showFieldOne.enName];
                if(!showFieldDataRow) {
                    showFieldDataRow = "";
                }
                //获取每一行数据的主键
                var elementMainId = element.IDS;
                var oneRowJson = {};
                    //是否已经拼接过行分组的rowKey信息 没有拼接过 进行拼接
                var addTableDataFlag = false;
                if(!initAutoData.tmpDataMap[rowKey+"_"+showFieldIndex]) {
                    oneRowJson = JSON.parse(JSON.stringify(initOneRowJson));
                    oneRowJson.showField = cnName;
                    oneRowJson.ctPageType = ctPageType;
                    oneRowJson.ctPageId = ctPageId;
                    oneRowJson.ctPageObjTableId = ctPageObjTableId;
                    initAutoData.tmpDataMap[rowKey+"_"+showFieldIndex] = oneRowJson;
                    addTableDataFlag = true;
                } else {
                    oneRowJson = initAutoData.tmpDataMap[rowKey+"_"+showFieldIndex];
                }
                //根据列分组 获取列的下标
                var tmpColIndex = initAutoData.tmpHeadMap[colKey].colIndex;
                
                var tmpValue = oneRowJson["row_" + tmpColIndex + "_sum"];// + "_" + enName
                var tmpNum = oneRowJson["row_" + tmpColIndex+"_num"];// + "_" + enName
                var finalValue = oneRowJson["row_" + tmpColIndex];
                //增加主键的数据 便于进行其他功能的开发
                var IDS = oneRowJson["row_"+tmpColIndex+"_id"];
                if(!IDS) {
                    IDS = "";
                } else {
                    IDS += ",";
                }
                IDS += elementMainId;
                if(tmpNum) {
                    tmpNum ++;
                } else {
                    tmpNum = 1;
                }
                switch (sumCheck) {
                    case "0": //记录数
                        if(!tmpValue) {
                            tmpValue = 0;
                        }
                        tmpValue += showFieldDataRow*1;
                        finalValue = tmpValue;
                        break;
                    case "1": //去重合并
                        if(!tmpValue) {
                            tmpValue = "";
                        } else {
                            tmpValue += ",";
                        }
                        tmpValue += showFieldDataRow;
                        finalValue = tmpValue;
                        break;
                    case "2": //最大值
                        if(!tmpValue) {
                            tmpValue = showFieldDataRow*1;
                        }
                        if(showFieldDataRow*1 > tmpValue) {
                            tmpValue = showFieldDataRow;
                        }
                        finalValue = tmpValue;
                        break;
                    case "3": //最小值
                        if(!tmpValue) {
                            tmpValue = showFieldDataRow*1;
                        }
                        if(showFieldDataRow*1 < tmpValue) {
                            tmpValue = showFieldDataRow;
                        }
                        finalValue = tmpValue;
                        break;
                    case "4": //总和
                        if(!tmpValue) {
                            tmpValue = 0;
                        }
                        
                        tmpValue += showFieldDataRow*1;
                        finalValue = tmpValue;
                        break;
                    case "5": //平均值
                        if(!tmpValue) {
                            tmpValue = 0;
                        }
                        tmpValue += showFieldDataRow*1;
                        finalValue = (tmpValue/tmpNum).toFixed(2);
                        break;
                    case "6": //合并
                        if(!tmpValue) {
                            tmpValue = "";
                        } else {
                            tmpValue += ",";
                        }
                        tmpValue += showFieldDataRow;
                        finalValue = tmpValue;
                        break;
                    case "7": //去重记录数
                        if(!tmpValue) {
                            tmpValue = 0;
                        }
                        tmpValue += showFieldDataRow*1;
                        finalValue = tmpValue;
                        break;
                    default:
                        break;
                }
                that.$set(oneRowJson,"row_" + tmpColIndex+"_sum",tmpValue);
                that.$set(oneRowJson,"row_" + tmpColIndex+"_num",tmpNum);
                that.$set(oneRowJson,"row_" + tmpColIndex,finalValue);
                that.$set(oneRowJson,"row_"+tmpColIndex+"_id",IDS);
                that.$set(oneRowJson,"row_id",elementMainId);
                if(addTableDataFlag) {
                    that.tableData.push(oneRowJson); 
                }
            });
        }
        initAutoData.startIndex = initAutoData.startIndex + endIndex;
        that.initAutoData = initAutoData;
        that.handleCurrentChange(1);
        if(dataRows.length > endIndex) {
            //进行递归调用
            // setTimeout(function(){
            //     that.rowDataCl();
            // },1000)
            // that.$nextTick(function(){
            //     that.rowDataCl();
            // }); 
        }
    },
    /**
     * 进行合并
     */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < this.rowFieldSize) {
            /*if(row["merge_"+columnIndex]) {
                return {
                    rowspan: row["merge_"+columnIndex],
                    colspan: 1
                };
            } else {
                return {
                    rowspan: 0,
                    colspan: 0
                };
            }*/
            if (rowIndex % this.showFieldLength === 0) {
                return {
                rowspan: this.showFieldLength,
                colspan: 1
                };
            } else {
                return {
                rowspan: 0,
                colspan: 0
                };
            }
        }
    },
    /**
     * 总和的统计
     */
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            values.forEach((curr,currentIndex) => {
                
            });
            sums[index] = values.reduce((prev, curr, currentIndex) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = 'N/A';
          }
        });

        return sums;
    },
    /**
     * 双击事件
     */
    cellDbClick(row, column, event){
        event = event || window.event;
        if(this.cellDbClickZdy) {
            this.cellDbClickZdy(row, column, $(event), this);
        }
    },
    getCellStyle(json){
        if(this.cellStyleZdy) {
            return this.cellStyleZdy(json);
        }
    },
    /**
     * 单击事件
     */
    cellClick(row, column, event) {
        var ctPageType = row.ctPageType;
        var ctPageId = row.ctPageId;
        var ctPageObjTableId = row.ctPageObjTableId;

        if(ctPageId > 0) {
            //获取穿透的页面的过滤主键
            var columnName = column.property;
	        var concatId = row[columnName+"_id"];
            this.$router.push({
                path:'listPage',
                query: {
                    tableId:ctPageObjTableId,
                    pageId:ctPageId,
                    ctType:1,
                    SourceDataId:this.reportId,
                    whereCond:concatId
                }
            });
        }
    },
    pageTabClick(tab, event){
        if(this.zdyPageTabClick) {
            this.zdyPageTabClick(tab, event, this);
        }
    },
    operaButtonCommand(command){
        if(command == -1) {
            this.exportReport();
        } else {
            if(this.zdyOperaButtonCommand) {
                this.zdyOperaButtonCommand(command);
            }
        }
    },
    /**
     * 切换图表类型
     */
    changeChartType(command) {
        var chartType = this.chartTypeArr[command];
        this.initChartOptions(chartType);
        this.chartType = chartType;
    },
    /**
     * 初始化图表的样式设置
     */
    initChartOptions(chartType){
        var that = this;
        var chartSettings = this.chartSettings;
        var chartData = this.chartData;
        if(chartType == "饼图" || chartType == "环图") {
            var pieChartSettings = {};
            pieChartSettings.dimension = chartSettings.dimension[0];
            pieChartSettings.metrics = chartSettings.metrics[0];
            this.pieChartSettings = pieChartSettings;
            var pageSet = that.pageSet;
            var pieChartOptions = {
                title:{
                    show:(!pageSet.styleSet || pageSet.styleSet.titleIfShow != 1)?false:true,
                    text:pageSet.name,
                    left: (pageSet.styleSet && pageSet.styleSet.titleLeft)?pageSet.styleSet.titleLeft:'auto',
                    top: (pageSet.styleSet && pageSet.styleSet.titleTop)?pageSet.styleSet.titleTop:'auto',
                    right: (pageSet.styleSet && pageSet.styleSet.titleRight)?pageSet.styleSet.titleRight:'auto',
                    buttom: (pageSet.styleSet && pageSet.styleSet.titleButtom)?pageSet.styleSet.titleButtom:'auto'
                },
                legend:{
                    show:(!pageSet.styleSet || pageSet.styleSet.legendIfShow != 2)?true:false,
                    type: 'scroll',
                    formatter:function(params){
                        var value = null;
                        chartData.rows.forEach(element => {
                            if(element[chartSettings.dimension[0]] == params) {
                                value = element[chartSettings.metrics[0]];
                            }
                        });
                        return params + (value!=null?(':'+value+'个'):'');
                    },
                    orient: (pageSet.styleSet && pageSet.styleSet.legendOrient)?pageSet.styleSet.legendOrient:'horizontal',
                    left: (pageSet.styleSet && pageSet.styleSet.legendLeft)?pageSet.styleSet.legendLeft:'auto',
                    top: (pageSet.styleSet && pageSet.styleSet.legendTop)?pageSet.styleSet.legendTop:'auto',
                    right: (pageSet.styleSet && pageSet.styleSet.legendRight)?pageSet.styleSet.legendRight:'auto',
                    buttom: (pageSet.styleSet && pageSet.styleSet.legendButtom)?pageSet.styleSet.legendButtom:'auto',
                    itemWidth:(pageSet.styleSet && pageSet.styleSet.legendItemWidth)?pageSet.styleSet.legendItemWidth:15,
                    itemHeight:(pageSet.styleSet && pageSet.styleSet.legendItemHeigth)?pageSet.styleSet.legendItemHeigth:7,
                    textStyle:{
                        fontSize:(pageSet.styleSet && pageSet.styleSet.legendFontSize)?pageSet.styleSet.legendFontSize:12
                    }
                },
                series:{
                    type:'pie',
                    radius: (pageSet.styleSet && pageSet.styleSet.seriesRadius)?eval(pageSet.styleSet.seriesRadius):[0,'75%'],
                    center: (pageSet.styleSet && pageSet.styleSet.seriesCenter)?eval(pageSet.styleSet.seriesCenter):['50%','50%'],
                    label:{
                        show: (pageSet.styleSet && pageSet.styleSet.seriesLabelIfShow)?pageSet.styleSet.seriesLabelIfShow:false,
                        position:(pageSet.styleSet && pageSet.styleSet.seriesLabelPosition)?pageSet.styleSet.seriesLabelPosition:'outside',
                        formatter:(pageSet.styleSet && pageSet.styleSet.seriesLabelFormatter)?pageSet.styleSet.seriesLabelFormatter:null
                    }
                }
            }
            this.pieChartOptions = pieChartOptions;
        }
    },
    /**
     * 切换图表的分组条件
     */
    changeChartGroup(command){
        var reportSetData = this.reportSetData;
        this.groupCheckOne = this.groupArr[command];
        if(this.groupCheckOne.type == "row") {
            reportSetData.rowCheckList = [this.groupCheckOne.index];
            reportSetData.colCheckList = [];
        } else {
            reportSetData.rowCheckList = [];
            reportSetData.colCheckList = [this.groupCheckOne.index];
        }
        this.initSearchData();
    },
    /**
     * 选择分页 当前页时触发
     */
    handleCurrentChange(val) {
        if(this.ifCurrent == 1) {
            this.currentPage = val;
            var nowPage = (val-1);
            var pageTableData = [];
            
            var endIndex = 10;
            var startIndex = nowPage*10;
            if(this.tableData.length - nowPage*10 < 10) {
                endIndex = this.tableData.length - nowPage*10;
            }
            for (let index = startIndex; index < startIndex+endIndex; index++) {
                pageTableData.push(this.tableData[index]);
            }
            this.pageTableData = [];
            var that = this;
            this.$nextTick(function(){
                that.pageTableData = pageTableData;
            }); 
        } else {
            this.pageTableData = this.tableData;
        }
    },
    changeBlockFlag(){
        if(this.rightBlockInfo.blockWidth == "70px") {
            this.rightBlockInfo.blockWidth = "200px";
            this.rightBlockInfo.buttonName = "收起";
        } else {
            this.rightBlockInfo.blockWidth = "70px"
            this.rightBlockInfo.buttonName = "展开";
        }
    },
    tenDepChartClicked :function(e){
        // console.log("e=======================",e);
        var dataIndex = e.dataIndex;
        var chartData = this.chartData;
        var dataOne = chartData.rows[dataIndex];
        // console.log("dataOne=======================",dataOne);
        this.pageSetInfo = this.pageSet;
        this.pageSetInfo.listStyleSet = this.pageSetInfo.styleSet;
        pageUtils.listDataClick(this, dataOne);
    }
  },
  created:function(){
    var paramsJson = this.$route.query;
    // console.log("this.pageInfo=====1111111111==========",this.pageInfo);
    if(this.pageInfo) {
        this.reportId = this.pageInfo.reportId;
    } else if(paramsJson.reportId > 0) {
        this.reportId = paramsJson.reportId;
    }
  },
  /**
   * 页面创建时 进行后台数据请求 请求页面设置信息 之后再做浏览器端缓存
   */
  beforeMount : function(){
    var that = this;
    if(!this.initReportType || this.initReportType == 0) {
        this.reportType = false;
    } else {
        this.reportType = true;
    }
    
    //计算页面高度 设置表格的最大高度 tableMaxHeight
    var windowHeight = window.innerHeight-230;//
    this.tableMaxHeight = windowHeight;
    var reportId = this.reportId;
    var url = "/wxXcxSet_interfaceToReport.do";
    this.loading = true;
    utils.request(that,{
        url:url,
        data:{
            reportId: reportId
        },
        success: function (res) {
            that.loading = false;
            if (res.data) {
                var reportSet = res.data;
                that.searchSetArr = reportSet.fieldSet;
                //构建搜索时需要提交到后台的数据信息
                if(that.searchSetArr != null) {
                    that.$refs.ListSearch.toHtSearchData = pageUtils.initToHtSearchData(that);
                }
                var tmpPageSet = that.pageSet;
                //报表名称
                tmpPageSet.name = reportSet.name;
                //搜索条件的面板 默认收起还是展开 
                tmpPageSet.ifUnfoldsrch = reportSet.ifUnfoldsrch+"";
                //是否进行记录数的加载
                tmpPageSet.ifSearchCount = reportSet.ifSearchCount;
                //是否隐藏统计列的显示 1是隐藏
                tmpPageSet.ifHideTjCol = reportSet.ifHideTjCol;

                var reportSetData = {
                    dateType:"0",
                    rowOrCol:"0",
                    rowMin:1,
                    colMin:1
                };
                var rowCheckList = [];
                reportSet.rowFieldList.forEach((element,rowFieldIndex) => {
                    rowCheckList.push(rowFieldIndex);
                });
                reportSetData.rowCheckList = rowCheckList;
                var colCheckList = [];
                reportSet.colFieldList.forEach((element,colFieldIndex) => {
                    colCheckList.push(colFieldIndex);
                });
                reportSetData.colCheckList = colCheckList;
                that.reportSetData = reportSetData;
                //行分组信息
                tmpPageSet.rowFieldList = reportSet.rowFieldList;
                //列分组信息
                tmpPageSet.colFieldList = reportSet.colFieldList;
                //统计字段信息
                tmpPageSet.showFieldList = reportSet.showFieldList;

                tmpPageSet.styleSet = reportSet.styleSet;

                //是否进行分页
                that.ifCurrent = reportSet.iffdzjsj;
                //分页条数
                that.pageSize = (reportSet.jzsjts && reportSet.jzsjts != "")?reportSet.jzsjts:10;
                if(tmpPageSet.styleSet && tmpPageSet.styleSet.ifChart == 2) {
                    that.reportType = true;
                }

                //自定义js
                var zdyLoadJs = reportSet.zdyLoadJs;
                
                if(zdyLoadJs) {
                    eval(zdyLoadJs);
                }
                that.pageSet = tmpPageSet;

                if(that.reportType) {
                    that.changeReportType();
                } else {
                    //是否默认加载数据
                    if(reportSet.ifDefaultLoad == 0) {
                        that.initSearchData();
                    }
                }

            } else{
                //登陆失败
                this.$message({
                    showClose: true,
                    message: '页面信息获取失败了，请重试!',
                    type: 'error'
                });
            }
        }
    })
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
